import { memoize } from "lodash";
import { observable, runInAction } from "mobx";
import { apiCallGetUserConsumables } from "../../../api/user-api/api-call-get-user-consumables";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";
import { TUserConsumablesData } from "../../../Types";
import { isDefinedString } from "et3-type-guards";
import queryString from "query-string";

class UserConsumablesStore {
  userID = observable.box<number>(0);
  consumablesData = observable.box<TUserConsumablesData>({
    boostNextRenewalDate: "",
    rewindNextRenewalDate: "",
    readReceiptNextRenewalDate: "",
    chatWeeklyNextRenewalDate: "",
    chatDailyNextRenewalDate: "",
    payingBoostPackageUntil: "",
    payingRewindPackageUntil: "",
    meteredBoostCount: "",
    quotaBoostCount: "",
    meteredRewindCount: "",
    quotaRewindCount: "",
    meteredReadReceiptCount: "",
    quotaReadReceiptCount: "",
    meteredChatWeeklyCount: "",
    meteredChatDailyCount: ""
  });

  setUserID = (id: number) => {
    runInAction(() => {
      this.userID.set(id);
    });
  };

  setConsumablesData = (data: TUserConsumablesData) => {
    runInAction(() => {
      this.consumablesData.set(data);
    });
  };

  getUserConsumablesData = async () => {
    getCoreUIStore().setIsLoading("USER_CONSUMABLES", true);
    const { data, code, status } = await apiCallGetUserConsumables({
      userID: this.userID.get()
    });

    getCoreUIStore().setIsLoading("USER_CONSUMABLES", false);
    if (status === "ERROR") {
      getCorePopUpStore().showAlertMessage(code);
    }
    if (status === "OK") {
      this.setConsumablesData(data);
    }
  };

  checkURLSearch = async (search: string) => {
    if (isDefinedString(search)) {
      const searchID = queryString.parse(search).id;
      if (isDefinedString(searchID) && searchID !== "0") {
        const searchIDNumber = parseInt(searchID, 10);
        getUserConsumablesStore().setUserID(searchIDNumber);
        await this.getUserConsumablesData();
      }
    }
  };
}

const getUserConsumablesStore = memoize(
  () => new UserConsumablesStore(),
  () => 1
);
export default getUserConsumablesStore;
